import { Schema } from '@blade/std-lib'

// https://oembed.com/ subset used by https://embed.bsky.app/oembed
// https://embed.bsky.app/oembed?url=https://bsky.app/profile/d20plusmodifier.bsky.social/post/3mi2pdyjbfs2m
export class BlueskyPostOembed extends Schema.Class<BlueskyPostOembed>(
  'BlueskyPostOembed',
)({
  html: Schema.String,
}) {
  static decode = Schema.decodeUnknownOption(BlueskyPostOembed)

  get hasVisibleContent(): boolean {
    return this.html.trim().length > 0
  }
}
